import React, { useState } from 'react';
import { Tooltip, TooltipProps } from 'ui-components/tooltip/tooltip';
import { CopyToClipboard as CopyToClipboardUtil } from 'react-copy-to-clipboard';

interface CopyToClipboardProps {
    copyValue: string;
    children: JSX.Element;
    stopEventPropagation?: boolean;
    tooltipConfig?: Partial<TooltipProps>;
}

export const CopyToClipboard = ({
    copyValue,
    children,
    stopEventPropagation,
    tooltipConfig,
}: CopyToClipboardProps) => {
    const [tooltipText, setTooltipText] = useState<string>('Click to copy');
    return (
        <CopyToClipboardUtil text={copyValue}>
            <Tooltip title={tooltipText} {...tooltipConfig}>
                {React.cloneElement(children, {
                    onClick: (e: MouseEvent) => {
                        setTooltipText('Copied to clipboard');
                        setTimeout(() => setTooltipText('Click to copy'), 1000);
                        stopEventPropagation && e.stopPropagation();
                    },
                })}
            </Tooltip>
        </CopyToClipboardUtil>
    );
};
